<section class="container-fluid p-0">
  <div class="row p-3 tab-container">
    <div
      class="col-sm offer-tab pointer pr-0"
      [class.active]="i === page"
      (click)="onClickTab(i)"
      *ngFor="let pageElement of pages; let i = index"
    >
      <div class="arrow-tail float-left" *ngIf="i !== 0">
        <svg viewBox="0 0 27.29 50">
          <path class="cls-1" d="M27.29,0H0L1.86,1.86,25,25,1.86,48.14,0,50H27.29" />
        </svg>
      </div>

      <span>
        <i class="partnerhub-icons" [innerHtml]="pageElement?.icon"></i>

        {{ pageElement?.label | translate }}
      </span>

      <div class="arrow-point float-right" *ngIf="i !== pages.length - 1">
        <svg viewBox="0 0 27.69 50">
          <path class="cls-1" d="M0,50H2.28L27,25.77c.21-.21.73-.77.73-.77s-.52-.56-.73-.77C27,24.23,2.57,0,2.28,0H0" />
        </svg>
      </div>
    </div>
  </div>

  <ng-content></ng-content>

  <div class="text-center" *ngIf="showNavButtons">
    <button *ngIf="page !== 0" (click)="onClickBack()" type="button" class="btn btn-secondary previous btn-sm">
      {{ 'offers.back' | translate }}
    </button>

    <button
      *ngIf="page !== pages.length - 1; else submit"
      (click)="onClickNext()"
      type="button"
      class="btn btn-secondary next btn-sm ml-3"
    >
      {{ 'offers.next' | translate }}
    </button>
  </div>
</section>

<ng-template #submit>
  <ng-container *ngIf="showSubmit">
    <button (click)="onClickSubmit()" type="button" class="btn btn-secondary btn-sm ml-3">
      {{ 'offers.submit' | translate }}
    </button>
  </ng-container>
</ng-template>
